import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import getInTouch from "../assets/getintouch.png";
import aboutBanner2 from "../assets/about_banner2.png";
import CoreServices from "../components/CoreServices";
import EquipmentInfrastructure from "../components/EquipmentInfrastructure";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <div>
      <Header />
      <div className="relative w-full">
        {/* Banner Image */}
        <img
          src={aboutBanner2}
          alt="aboutBanner"
          className="w-full h-auto object-cover banner-img"
        />

        {/* Overlay Text */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h2
            data-aos="fade-up"
            className="text-white text-4xl md:text-5xl  title-font-heading"
          >
            What we do
          </h2>
        </div>
      </div>
      <CoreServices />
      <EquipmentInfrastructure />
      {/* Get in Touch */}
      <section className="bg-[#1C3E9A] text-white px-6 main-cta-card md:px-28">
        <div className="col-flex flex flex-col md:flex-row items-center justify-between">
          {/* Left: Text */}
          <div className="md:w-1/2 text-center md:text-left cta-headong">
            <h3 data-aos="fade-up">Get in Touch</h3>
            <h2 data-aos="fade-up">
              Time to take action? <br className="hidden md:block" />
              Get a quote today
            </h2>
            <Link to="/contact">
              <button
                data-aos="fade-up"
                className="uppercase bg-white text-[#1C3E9A] px-6 py-2 mt-6 rounded-full"
              >
                Get a Quote
              </button>
            </Link>
          </div>

          {/* Right: Image */}
          <div className="md:w-1/2 mt-8 md:mt-0 flex justify-center">
            <img
              data-aos="zoom-in-up"
              src={getInTouch}
              alt="Engineers"
              className="h-90 w-100 object-contain"
            />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Services;
